import { DateTime } from 'luxon'

export class ChargeRange {
    constructor(
        public minPartySize: number | null,
        public maxPartySize: number | null,
        public unitAmount: number | null,
        public isPerCover: boolean,
        public startDate: string | null,
        public endDate: string | null,
        public cutOffHours: number | null
    ) { }

    isApplicable(partySize: number, dateTime: Date, timeZone: string): boolean {
        if (this.minPartySize !== null && partySize < this.minPartySize) {
            return false
        }
        if (this.maxPartySize !== null && partySize > this.maxPartySize) {
            return false
        }
        if (this.startDate !== null) {
            const start = DateTime.fromISO(this.startDate, { zone: timeZone }).startOf('day').toJSDate()
            if (dateTime < start) {
                return false
            }
        }
        if (this.endDate !== null) {
            const end = DateTime.fromISO(this.endDate, { zone: timeZone }).endOf('day').toJSDate()
            if (dateTime > end) {
                return false
            }
        }
        return true
    }
}
